/* 무료배송 진행 배너 (Young 2026-08-19).
   ⚠️ 레퍼런스(sugarandcanvas)의 결함을 답습하지 않는다 — 그 사이트는 무료배송 미적용 국가(예: 한국)에도
      "You've Got Free Shipping"을 띄우고 체크아웃에서 배송비가 붙는다. 우리는 국가를 보고 문구를 가른다.
   ⚠️ 임계값은 샵 통화(USD) 기준으로 Shopify가 판정한다 → 표시도 Shopify.currency.rate로 환산해 일치시킨다.
   ⚠️ 금액·문구는 전부 섹션 설정에서 온다(하드코딩 금지). */
(function () {
    var el = document.querySelector('.js-freeship');
    if (!el) return;

    var cfg = {
        threshold: parseFloat(el.dataset.threshold || '0'),
        eligible: (el.dataset.eligible || '').toUpperCase().split(',').map(function (s) { return s.trim(); }),
        country: (el.dataset.country || '').toUpperCase(),
        tDefault: el.dataset.textDefault || '',
        tProgress: el.dataset.textProgress || '',
        tSuccess: el.dataset.textSuccess || '',
        tOther: el.dataset.textOther || '',
        countryName: el.dataset.countryName || '',
        suffixOther: el.dataset.suffixOther || '',
        theCountries: (el.dataset.theCountries || '').toUpperCase().split(',').map(function (s) { return s.trim(); }),
        rateDefault: parseFloat(el.dataset.rateDefault || '0'),
        rates: (function () { try { return JSON.parse(el.dataset.rates || '{}'); } catch (e) { return {}; } })(),
        freeAll: (el.dataset.freeAll || '').toUpperCase().split(',').map(function (s) { return s.trim(); }),
        tFree: el.dataset.textFree || '',
        suffix: el.dataset.suffix || ''
    };
    var target = el.querySelector('.js-freeship-text') || el;

    function rate() {
        var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
        return (r && !isNaN(r)) ? r : 1;
    }

    function fmt(cents) {
        var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en', {
                style: 'currency', currency: cur, minimumFractionDigits: 2
            }).format(cents / 100);
        } catch (e) {
            return (cents / 100).toFixed(2) + ' ' + cur;
        }
    }

    /* 금액은 알약 배지로 감싼다(레퍼런스와 동일). textContent 대신 노드로 조립 — innerHTML 미사용. */
    function render(tpl, token, value) {
        target.textContent = '';
        var parts = (token && tpl.indexOf(token) > -1) ? tpl.split(token) : [tpl];
        parts.forEach(function (p, i) {
            if (p) target.appendChild(document.createTextNode(p));
            if (i < parts.length - 1) {
                var pill = document.createElement('span');
                pill.className = 'freeship-amount';
                pill.textContent = value;
                target.appendChild(pill);
            }
        });
        var suf = (cfg.eligible.indexOf(cfg.country) === -1)
            ? cfg.suffixOther.replace('[country]', countryPhrase())   // 미적용 국가는 그 나라 이름으로
            : cfg.suffix;
        if (suf) target.appendChild(document.createTextNode(' ' + suf));
    }

    /* 영어 국가명 중 정관사가 붙는 것들("the Philippines")만 붙인다 — 목록은 섹션 설정. */
    function countryPhrase() {
        var needsThe = cfg.theCountries.indexOf(cfg.country) > -1;
        return (needsThe ? 'the ' : '') + cfg.countryName;
    }

    function paint(cartCents) {
        var txt;
        if (cfg.eligible.indexOf(cfg.country) === -1) {
            // 무료배송 미적용 국가 — 약속하지 않고 그 나라 실제 flat rate를 알려준다
            var flat = parseFloat(cfg.rates[cfg.country] || cfg.rateDefault) || 0;
            render(cfg.tOther.replace('[country]', cfg.countryName), '[rate]',
                   fmt(Math.round(flat * rate() * 100)));
            return;
        }
        /* 최소주문 없는 국가(2026-09-23 US) — 장바구니 금액과 무관하게 한 문구로 고정한다. */
        if (cfg.freeAll.indexOf(cfg.country) > -1) {
            render(cfg.tFree, null, null);
            return;
        }
        var thr = Math.round(cfg.threshold * rate() * 100);
        if (cartCents <= 0) {
            render(cfg.tDefault, '[amount]', fmt(thr));
        } else if (cartCents >= thr) {
            render(cfg.tSuccess, null, null);
        } else {
            render(cfg.tProgress.replace('[amount]', fmt(thr)), '[remaining]', fmt(thr - cartCents));
        }
    }

    function refresh() {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (c) { paint(c.total_price || 0); })
            .catch(function () { /* 무음 폴백 금지 — 서버 렌더 문구를 그대로 둔다 */ });
    }

    refresh();
    document.addEventListener('postera:cart-updated', refresh);
    if (window.jQuery) {
        window.jQuery(document.body).on(
            'afterAddItem.ajaxCart afterChangeItem.ajaxCart afterCartLoad.ajaxCart afterGetCart.ajaxCart',
            refresh);
    }
})();
